import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { formatDunsNumber } from '../../dataHandlers/riskCompliancePaths';

import { riskButtonSx } from './riskComplianceStyles';

export default function DunsUnlinkConfirmModal({ open, onClose, dunsNumber, labels, onConfirm, isUnlinking }) {
  const formattedDuns = formatDunsNumber(dunsNumber);
  const description = (labels.description ?? '').replace('{duns}', formattedDuns);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>{labels.title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
        <Button variant="outlined" onClick={onClose} disabled={isUnlinking} sx={riskButtonSx}>
          {labels.cancel}
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm} disabled={isUnlinking} sx={riskButtonSx}>
          {labels.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
